"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classNames = _interopRequireDefault(require("../classNames"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Layout = _interopRequireDefault(require("../Layout"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/NavBar/index.js";
var defaultProps = {
  icon: 'bi bi-list',
  logo: '/assets/images/logo.svg'
};
function NavBar(_ref) {
  var className = _ref.className,
    onToggle = _ref.onToggle,
    icon = _ref.icon,
    logo = _ref.logo,
    children = _ref.children,
    title = _ref.title,
    titleClick = _ref.titleClick;
  var classes = (0, _classNames["default"])(className, "navbar navbar-expand-lg navbar-light bg-white");
  var _React$useContext = _react["default"].useContext(_Layout["default"].Context),
    collapsed = _React$useContext.collapsed,
    setCollapse = _React$useContext.setCollapse;
  var location = (0, _reactRouterDom.useLocation)();
  // listen to the changes of URL
  _react["default"].useEffect(function () {
    setCollapse(false);
  }, [location, setCollapse]);
  function click() {
    if (onToggle) {
      onToggle();
    } else {
      setCollapse(!collapsed);
    }
  }
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: click,
    type: "button",
    className: "btn btn-sm btn-link fs-4 ps-0 text-dark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 21
    }
  })), /*#__PURE__*/_react["default"].createElement("a", {
    href: "# ",
    onClick: titleClick,
    className: "navbar-brand me-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 17
    }
  }), logo && /*#__PURE__*/_react["default"].createElement("img", {
    className: "w-auto me-2",
    height: "38",
    src: logo,
    alt: "logo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 21
    }
  }), /*#__PURE__*/_react["default"].createElement("a", {
    href: "# ",
    onClick: titleClick,
    className: "navbar-brand me-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 17
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: click,
    type: "button",
    className: "btn btn-sm btn-link fs-4 ps-0 text-dark d-none",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-person-circle",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 21
    }
  }))));
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: click,
    type: "button",
    className: "btn btn-sm btn-link fs-4 ps-0 text-dark",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 21
    }
  })), /*#__PURE__*/_react["default"].createElement("a", {
    href: "# ",
    onClick: titleClick,
    className: "navbar-brand me-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 17
    }
  }, logo && /*#__PURE__*/_react["default"].createElement("img", {
    className: "w-auto me-2",
    height: "38",
    src: logo,
    alt: "logo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 33
    }
  }), title && title), children));
}
NavBar.defaultProps = defaultProps;
var _default = NavBar;
exports["default"] = _default;